import React, {useState} from "react"
import { StaticQuery, graphql } from "gatsby"
import Layout from "../components/layout"
import ReactMarkdown from "react-markdown"



const PrivacyPolicyPage = () =>{
return (
<Layout>
    <StaticQuery
    query={graphql`
    query {
        strapiPrivacyPolicy {
          Text
          Title
        }
      }`}

      render={data => (
      <>
                 <style>{
    `#background{
      transform: rotate(46deg);
      bottom: -29%;
    }   
    @media only screen and (max-width: 450px) {
    #background{
    transform: rotate(cal(var(--esq)*var(--dir))) scale(1.2);
    bottom: -5% !important;
    }
    .title{
      margin-top:30px !important;
      font-size: 22px !important;
    }
  }    
      
  }
  
    `}
  </style>
        <h1 className="title" style={{marginTop:"0px"}}>{data.strapiPrivacyPolicy.Title}</h1>
        <div className="privacyPolicyText">
            <ReactMarkdown>{data.strapiPrivacyPolicy.Text}</ReactMarkdown>
        </div>
        
      </>)}
    />
    
</Layout>)
}

export default PrivacyPolicyPage